import { Control, Controller } from "react-hook-form";
import styled from "styled-components";
import { FC, useState } from "react";
import { CountryDropdown, DropdownInputBorderVariant } from "../ui-kit";
import { Country } from "../../constants/countries";
import { FlagIconCode } from "react-flag-kit";

const Container = styled.div`
  padding-top: 20px;
`;

interface CountryDropdownFormFieldProps {
  name: string;
  className?: string;
  control: Control<any>;
  label: string;
  fullWidth?: boolean;
}

export const CountryDropDownFormField: FC<CountryDropdownFormFieldProps> = ({
  name,
  className,
  control,
  label,
  fullWidth,
}) => {
  const [internalValue, setInternalValue] = useState<Country>({
    country: "GB",
    countryName: "United Kingdom",
    code: "+44",
  });
  const handleChange =
    (onChange: (value: FlagIconCode) => void) => (val: Country) => {
      setInternalValue(val);
      onChange(val.country);
    };

  return (
    <Container className={className}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          const variant = () => {
            if (error != null) {
              return DropdownInputBorderVariant.ERROR;
            } else {
              return DropdownInputBorderVariant.DEFAULT;
            }
          };
          return (
            <CountryDropdown
              fullWidth={fullWidth}
              value={internalValue}
              label={label}
              onChange={handleChange(field.onChange)}
              borderVariant={variant()}
              error={error?.message}
            />
          );
        }}
      />
    </Container>
  );
};
